var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#FCFBFC"}},[_c('dss-card',{staticClass:"index-model-3",attrs:{"wrap-width":_vm.wrapWidth,"title":"核心技术能力：真实世界知识图谱和大语言模型的融合迭代能力"}},[_c('div',{staticStyle:{"margin-top":"60px"}},[_c('v-img',{attrs:{"src":_vm.coreTech}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bfbe188","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/pc/home/prodCore/coreTechnology.vue
// module id = null
// module chunks = 